<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Laporan Mukim"
        :crumbs="crumbs"
    >
        <z-page :title="`Senarai Mukim Berdasarkan Daerah`" :append-button="true">
            <w-flex column :gap="3">
                  <w-form @submit.prevent="dataJHM()">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-select
                              :items="districts"
                              v-model="searchParams.daerah"
                              outline
                              label="Pilih Daerah"
                              label-position="left"
                            >
                            </w-select>
                            <w-button
                                :loading="loading"
                                class="align-self-end"
                                type="submit"
                            >
                            <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </w-flex>
                    </w-flex>
                </w-form>
                <w-flex class="justify-space-between">
                    <w-button class="align-self-end"
                    bg-color="success"
                    :loading="loading"  @click="printPdf()">
                        <w-icon class=" mr2 "> fal fa-print</w-icon>
                        Cetak&nbsp;
                    </w-button>
                </w-flex>
            <table class="table-dashboard" cellpadding="1.5px" cellspacing="0" style="width: 100%;  border-collapse: collapse;">
                <thead>
                    <tr>
                        <td style="width:20%;">Kod Mukim</td>
                        <td style="width:40%;">Mukim</td>
                        <td style="width:20%;">Jumlah Hakmilik</td>
                    </tr>
                </thead>
                <tbody v-for="mukim in mukim"  >
                    <tr >
                        <td>{{ mukim.kod_mukim}}</td>
                        <td>{{ mukim.mukim}}</td>
                        <td>{{ mukim.bilangan }}</td>
                    </tr>
                </tbody>
            </table>
            </w-flex>

        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";


export default {
    extends: ZResource,
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],

            districts: [{ label: "Loading", selected: true }],
            mukim:[],
            searchParams: {
                daerah: "01",
            },
        };
    },
    methods: {
        printPdf(){
            window.open( `${this.apiBaseUrl}/cukai/laporan/mukimPdf?daerah=${this.searchParams.daerah}`,"_blank");
        },
        async fetchDaerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                return {
                  label: d.kod + " - " + d.keterangan,
                  value: d.id,
                };
        });
            });
        },
        async getDaerah(){
            this.loading = true;
            await axios({
                    method: "get",
                    url: `${this.apiBaseUrl}/jabatanToDaerah?jabatan=${this.$page.props.auth.user.jabatan_id}`,
                    responseType:'json',
                }).then((e)=>{
                    this.searchParams.daerah=e.data[0].lkp_daerah_id;
                    // this.fetchData2();
                }).finally((e) => {
                    this.dataJHM();
                });;
        },
        async dataJHM() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/laporan/mukim?daerah=${this.searchParams.daerah}`,
                responseType: "json",
            }).then((e) => {
                this.mukim = e.data
                this.loading = false;
            });
        },
    },
    computed: {

    },
    mounted() {
        this.getDaerah();
        this.fetchDaerah();
    },
};
</script>
